module.exports = __webpack_public_path__ + "static/media/0_cart@2x.bfb0dfce.jpg";